function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6893 18.3914C21.131 16.6584 21.998 14.4305 21.998 12.0001C21.998 6.47721 17.5209 2.00006 11.998 2.00006C6.4752 2.00006 1.99805 6.47721 1.99805 12.0001C1.99805 17.5229 6.4752 22.0001 11.998 22.0001C14.1036 22.0001 16.0571 21.3493 17.6686 20.238C17.6858 20.2471 17.7041 20.2552 17.7233 20.262L19.9382 21.0464C20.2554 21.1587 20.5611 20.853 20.4488 20.5358L19.6893 18.3914Z",
    fill: "#147AFF",
    style: {
      fill: "#147AFF",
      fill: "color(display-p3 0.0784 0.4784 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.00195,
    cy: 12,
    r: 1.4,
    fill: "white",
    stroke: "#979797",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1,
      stroke: "#979797",
      stroke: "color(display-p3 0.5922 0.5922 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1.4,
    fill: "white",
    stroke: "#979797",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1,
      stroke: "#979797",
      stroke: "color(display-p3 0.5922 0.5922 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.998,
    cy: 12,
    r: 1.4,
    fill: "white",
    stroke: "#979797",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1,
      stroke: "#979797",
      stroke: "color(display-p3 0.5922 0.5922 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsSelected);
export default __webpack_public_path__ + "static/media/chats-selected.0978edf418b58654e7f9d171e9d8681d.svg";
export { ForwardRef as ReactComponent };